import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import "./style.scss";
import { useTranslation } from "react-i18next";
import EADivider from "../../shared/EADivider";

type CardBalanceProps = {
  userDataOverride?: State["auth"]["userData"];
};

const CardBalance: React.FC<CardBalanceProps> = ({ userDataOverride }) => {
  const userDataFromStore = useSelector((state: State) => state.auth.userData);
  const userData = userDataOverride ?? userDataFromStore;
  const { t } = useTranslation();

  if (!userData) {
    return null;
  }

  const balances: { key: string; label: string; amount: string }[] = [];

  if (userData.captionDepositBalance !== "0.00" && userData.captionDepositBalance !== null) {
    balances.push({
      key: "deposit",
      label: userData.descriptionDepositBalance,
      amount: `${userData.captionDepositBalance} ${t("zl")}`,
    });
  }

  if (userData.captionBalanceI !== "0.00" && userData.captionBalanceI !== null) {
    balances.push({
      key: "balanceI",
      label: userData.descriptionBalanceI,
      amount: `${userData.captionBalanceI} ${t("zl")}`,
    });
  }

  if (userData.captionBalanceII !== "0.00" && userData.captionBalanceII !== null) {
    balances.push({
      key: "balanceII",
      label: userData.descriptionBalanceII,
      amount: `${userData.captionBalanceII} ${t("zl")}`,
    });
  }

  if (userData.captionBalanceIII !== "0.00" && userData.captionBalanceIII !== null) {
    balances.push({
      key: "balanceIII",
      label: userData.descriptionBalanceIII,
      amount: `${userData.captionBalanceIII} ${t("zl")}`,
    });
  }

  if (!balances.length) {
    return (
      <div className="ecard-balance-no-funds text-color-dark-gray">
        <span>{t("brak_srodkow")}</span>
      </div>
    );
  }

  return (
    <div className="ecard-balance-list">
      {balances.map((item, index) => (
        <React.Fragment key={item.key}>
          <div className="ecard-balance-row">
            <span className="ecard-balance-label text-color-dark">{item.label}</span>
            <span className="ecard-balance-amount text-bold text-color-dark">{item.amount}</span>
          </div>
          {index < balances.length - 1 && <EADivider />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default CardBalance;
